import React, { useState } from "react";
import "./Navbar.css";
import { NavLink } from "react-router-dom";
import logo from "../../../assets/images/logo.png";

const Navbar = () => {

  const [navbar, setNavbar] = useState(false);
 

  const changeBackground = () => {
    if (window.scrollY >= 80) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  }

  window.addEventListener('scroll', changeBackground);

  // Function to close the offcanvas navbar
  const closeOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasNavbar");
    if (offcanvasElement) {
      const offcanvasInstance = window.bootstrap.Offcanvas.getInstance(
        offcanvasElement
      );
      offcanvasInstance?.hide();
    }
  };

  
  return (
    <>
        { /*<div className="social-media-bar bg-light text-center py-1 sticky-top">
  <div className="container d-flex justify-content-between align-items-center">
    <div className="email-text">
      <p className="my-2">Email us : <a href="mailto:info@nextechplm.com">info@nextechplm.com</a></p>
    </div>
    <div className="social-icons-container">
      <a href="https://www.linkedin.com/company/nextech-plm-solutions/" className="mx-2" target="_blank" rel="noopener noreferrer">
        <i className="fa-brands fa-linkedin"></i>
      </a>
      <a href="https://www.facebook.com/people/NexTech-PLM-Solutions/100091412807386/?mibextid=qi2Omg&rdid=EMNjdCqHkgnFCHJ0&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FvNf8TQB9UWD12RVY%2F%3Fmibextid%3Dqi2Omg" className="mx-2" target="_blank" rel="noopener noreferrer">
        <i className="fa-brands fa-facebook-f"></i>
      </a>
      <a href="https://www.instagram.com/nextech_plm_solutions/" className="mx-2" target="_blank" rel="noopener noreferrer">
        <i className="fa-brands fa-instagram"></i>
      </a>
      <a href="https://x.com/NextechPlm" className="mx-2" target="_blank" rel="noopener noreferrer">
        <i className="fa-brands fa-x-twitter"></i>
      </a>
    </div>
  </div>
   
</div> */}

  
      <nav className={navbar ? 'navbar navbar-expand-lg active' : 'navbar navbar-expand-lg'}>
      <div className="container">
        {/* logo */}
        <NavLink className="navbar-brand " to={"/"}>
          <img className="nextech-logo" src={logo} alt="Nextech logo" />
        </NavLink>

        {/* toggle button */}
        <button
          className="navbar-toggler shadow-none border-8"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* SideBar */}

        <div
          className="sidebar offcanvas offcanvas-start"
          tabIndex={-1}
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
        >
          {/* SideBar Header */}
         
          <div className="offcanvas-header border-bottom">
            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
              NextTechPLM
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white shadow-none"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>

          {/* SideBar Body */}
          <div className="offcanvas-body navbar-font">
            <ul className="navbar-nav justify-content-center flex-grow-1 pe-3">
              <li className="nav-item mx-2">
                <NavLink className="nav-link" to={"/about"} onClick={closeOffcanvas}>
                  About Us
                </NavLink>
              </li>
              <li className="nav-item mx-2">
                <a
                  className="nav-link dropdown-toggle text-decoration-none "
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  PLM Implementation
                </a>
                <div className="dropdown-menu dropdown-menu-dark container-fluid">
                  <div className="container">
                    <h1 className="pt-4 line">Teamcenter PLM Implementation</h1>
                    <table>
                      <tr>
                        <td>
                          <ul>
                          <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/implementation"
                                }  onClick={closeOffcanvas}
                              >
                                Teamcenter Implementation
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/plm-document-management"}
                                onClick={closeOffcanvas}
                              >
                                Document Management
                              </NavLink>
                            </li>
                           
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/mcad-integration"}
                                onClick={closeOffcanvas}
                              >
                                MCAD Integration
                              </NavLink>
                            </li>
                          
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/ecad-integration"}
                                onClick={closeOffcanvas}
                              >
                                ECAD Integration
                              </NavLink>
                            </li>
                           
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/business-process-management"}
                                onClick={closeOffcanvas}
                              >
                                Business Processes & Change Management
                              </NavLink>
                            </li>

                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/bom-management"
                                }
                                onClick={closeOffcanvas}
                              >
                                Product BOM and Variability Management
                              </NavLink>
                            </li>


                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/program-project-management"
                                }
                                onClick={closeOffcanvas}
                              >
                                Teamcenter Project Management
                              </NavLink>
                            </li>
                           
                          </ul>
                        </td>
                        <td>
                          <ul>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/performance-tuning-health-checkup"
                                }
                                onClick={closeOffcanvas}
                              >
                                Teamcenter Performance Tuning & Health Check-up
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/plm-erp-data-process-management"
                                }
                                onClick={closeOffcanvas}
                              >
                                PLM - ERP Data and Process Management
                              </NavLink>
                            </li>
                            
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/manufacturing-data-process-management"
                                }
                                onClick={closeOffcanvas}
                              >
                                Manufacturing Data and Process Management
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/cybersecurity"
                                }
                                onClick={closeOffcanvas}
                              >
                                Teamcenter Cyber Security
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/rac-to-aw-client-transition"
                                }
                                onClick={closeOffcanvas}
                              >
                                Teamcenter RAC to Active Workspace Client
                                Transition
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/cloud-implementation"
                                }
                                onClick={closeOffcanvas}
                              >
                                Teamcenter Implementation on Cloud
                              </NavLink>
                            </li>
                           
                          </ul>
                        </td>
                        <td>
                          <ul>
                          <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/reporting-analytics"}
                                onClick={closeOffcanvas}
                              >
                                Reporting and Analytics
                              </NavLink>
                            </li>

                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/aw-client"}
                                onClick={closeOffcanvas}
                              >
                                Implementation of Teamcenter AW Client
                              </NavLink>
                            </li>

                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/cae-integration"
                                }
                                onClick={closeOffcanvas}
                              >
                                Teamcenter Integration for CAE
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/cam-integration"
                                }
                                onClick={closeOffcanvas}
                              >
                                Teamcenter Integration for CAM
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/legacy-pdm-management"}
                                onClick={closeOffcanvas}
                              >
                                Legacy-PDM Management
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/teamcenter/upgrade-migration"
                                }
                                onClick={closeOffcanvas}
                              >
                                Teamcenter Upgrade & Migration
                              </NavLink>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </li>
              <li className="nav-item mx-2">
                <a
                  className="nav-link dropdown-toggle text-decoration-none"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Solutions
                </a>
                <div className="dropdown-menu dropdown-menu-dark container-fluid">
                  <div className="container">
                    <h1 className="pt-4 line">Solutions</h1>
                    <table>
                      <tr>
                        <td>
                          <ul>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/mendix-apps-solutions"}
                                onClick={closeOffcanvas}
                              >
                                Mendix Apps Solution
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/polarion-alm-solution"}
                                onClick={closeOffcanvas}
                              >
                                Polarian ALM Solution
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/redefining-plm-solution"}
                                onClick={closeOffcanvas}
                              >
                                Redefining PLM Solutions
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/sharepoint-insight-pdm-implementation"
                                }
                                onClick={closeOffcanvas}
                              >
                                SharePoint
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={
                                  "/Opcenter"
                                }
                                onClick={closeOffcanvas}
                              >
                                Opcenter Solutions
                              </NavLink>
                            </li>
                          </ul>
                        </td>
                        <td>
                          <ul>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/software-development-services"}
                                onClick={closeOffcanvas}
                              >
                                Software Development
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/support-consulting-services"}
                                onClick={closeOffcanvas}
                              >
                                Support and Consulting
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/staff-augmentation-services"}
                                onClick={closeOffcanvas}
                              >
                                Staff Augmentation
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/teamcenter/plm-solutions-amc"}
                                onClick={closeOffcanvas}
                              >
                                PLM Solutions AMC
                              </NavLink>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </li>
              <li className="nav-item mx-2">
                <NavLink className="nav-link" to={"/product-sales"} onClick={closeOffcanvas}>
                  Product Sales
                </NavLink>
              </li>
              <li className="nav-item mx-2">
                <NavLink className="nav-link " to={"/career"} onClick={closeOffcanvas}>
                  Careers
                </NavLink>
              </li>
            </ul>
            {/* contact us */}
            <div className="d-flex justify-content-center align-items-center gap-3">
              <NavLink
                to={"/contact"} onClick={closeOffcanvas}
                className=" text-decoration-none px-3 text-white py-1 contactusbutton rounded-4"
              >
                Contact Us
              </NavLink>
            </div>
          </div>
        </div>

      </div>
    </nav>
    </>
  );
};

export default Navbar;
